import { Chip } from "@material-tailwind/react";
import { t } from "i18next";
import { getQuotationStatusStyle } from "./quotationStatusStyles";

/**
 * QuotationsStatusDisplay: quotation status display component
 * Used to display a quotation status with soft background and dark text
 * @param status - status value
 * @param size - size options
 */
export default function QuotationsStatusDisplay(props: {
  status: string;
  size?: "sm" | "md" | "lg";
}) {
  const size = props.size ? props.size : "md";
  const textSize = size === "sm" ? "xs" : size === "md" ? "xs" : "base";

  if (!props.status) {
    return null;
  }

  const style = getQuotationStatusStyle(props.status);

  return (
    <Chip
      variant="ghost"
      size={size}
      value={t("quotation:status." + props.status.toLowerCase())}
      className={"w-fit h-fit rounded-full py-1 capitalize text-" + textSize}
      style={{ backgroundColor: style.soft, color: style.text }}
    />
  );
}
